import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PLAN_FEATURES, PlanInfo, TRIAL_CTA, TRIAL_LINK } from '../site.config';
import { ICON_PATHS } from './icons';

@Component({
    selector: 'site-price-card',
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <article
      class="relative flex h-full flex-col gap-[1.25rem] rounded-3xl border-[1px] border-solid bg-white p-6 sm:p-8"
      [class]="plan().highlight ? 'border-brand-700 shadow-xl' : 'border-surface-line'"
      [attr.aria-labelledby]="'plan-' + plan().id"
      data-test="price-card"
    >
      @if (plan().highlight) {
        <p class="absolute -top-3 left-6 rounded-full bg-coral-700 px-[0.75rem] py-1 text-xs font-semibold text-white">Yıllık planda ≈2 ay avantaj</p>
      }
      <h3 [id]="'plan-' + plan().id" class="text-xl">{{ plan().name }}</h3>
      <p class="flex flex-wrap items-baseline gap-x-2">
        <span class="text-4xl font-bold tracking-tight text-ink" data-test="price">{{ plan().priceDisplay }}</span>
        <span class="text-ink-muted">{{ plan().periodLabel }}</span>
      </p>
      <p class="text-sm text-ink-muted">KDV dahil · {{ plan().note }}</p>
      @if (showFeatures()) {
        <ul role="list" class="flex flex-col gap-2 text-sm">
          @for (feature of features; track feature) {
            <li class="flex gap-2">
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="mt-0.5 h-4 w-4 shrink-0 text-brand-700">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="icons.check" />
              </svg>
              <span>{{ feature }}</span>
            </li>
          }
        </ul>
      }
      <!-- Web'den ödeme (B) gelene kadar hedef deneme kaydı; ödeme uygulama içinden. -->
      <a
        [routerLink]="trial.path"
        [queryParams]="trial.queryParams"
        class="site-btn mt-auto"
        [class]="plan().highlight ? 'site-btn--primary' : 'site-btn--secondary'"
        >{{ trialCta }}</a
      >
    </article>
  `
})
export class PriceCardComponent {
  readonly plan = input.required<PlanInfo>();
  readonly showFeatures = input(false);
  readonly features = PLAN_FEATURES;
  readonly trial = TRIAL_LINK;
  readonly trialCta = TRIAL_CTA;
  readonly icons = ICON_PATHS;
}
